/**
 * @file menu-item.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _clickableComponentJs = require('../clickable-component.js');

var _clickableComponentJs2 = _interopRequireDefault(_clickableComponentJs);

var _componentJs = require('../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _objectAssign = require('object.assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

/**
 * The component for a menu item. `<li>`
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends Button
 * @class MenuItem
 */

var MenuItem = (function (_ClickableComponent) {
  _inherits(MenuItem, _ClickableComponent);

  function MenuItem(player, options) {
    _classCallCheck(this, MenuItem);

    _ClickableComponent.call(this, player, options);

    this.selectable = options['selectable'];

    this.selected(options['selected']);

    if (this.selectable) {
      // TODO: May need to be either menuitemcheckbox or menuitemradio,
      //       and may need logical grouping of menu items.
      this.el_.setAttribute('role', 'menuitemcheckbox');
    } else {
      this.el_.setAttribute('role', 'menuitem');
    }
  }

  /**
   * Create the component's DOM element
   *
   * @param {String=} type Desc
   * @param {Object=} props Desc
   * @return {Element}
   * @method createEl
   */

  MenuItem.prototype.createEl = function createEl(type, props, attrs) {
    return _ClickableComponent.prototype.createEl.call(this, 'li', _objectAssign2['default']({
      className: 'vjs-menu-item',
      innerHTML: this.localize(this.options_['label']),
      tabIndex: -1
    }, props), attrs);
  };

  /**
   * Handle a click on the menu item, and set it to selected
   *
   * @method handleClick
   */

  MenuItem.prototype.handleClick = function handleClick() {
    this.selected(true);
  };

  /**
   * Set this menu item as selected or not
   *
   * @param  {Boolean} selected
   * @method selected
   */

  MenuItem.prototype.selected = function selected(_selected) {
    if (this.selectable) {
      if (_selected) {
        this.addClass('vjs-selected');
        this.el_.setAttribute('aria-checked', 'true');
        // aria-checked isn't fully supported by browsers/screen readers,
        // so indicate selected state to screen reader in the control text.
        this.controlText(', selected');
      } else {
        this.removeClass('vjs-selected');
        this.el_.setAttribute('aria-checked', 'false');
        // Indicate un-selected state to screen reader
        // Note that a space clears out the selected state text
        this.controlText(' ');
      }
    }
  };

  /**
   * Return handler for the tooltip
   *
   * @return {Object} Dom element to serve as a handler for the tooltip
   * @method tooltipHandler
   */

  MenuItem.prototype.tooltipHandler = function tooltipHandler() {
    if (this.options_.tooltip !== undefined) {
      return _ClickableComponent.prototype.tooltipHandler.call(this);
    }
  };

  return MenuItem;
})(_clickableComponentJs2['default']);

_componentJs2['default'].registerComponent('MenuItem', MenuItem);
exports['default'] = MenuItem;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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